import React from "react";

import { Button, Modal, Table } from "antd";

import "./UnchangedWOModal.css";

export default function UnchangedWOModal({ woList = [], toggleModal }) {
  const closeButton = (
    <Button key="cancel" onClick={() => toggleModal(false)}>
      Close
    </Button>
  );

  return (
    <Modal
      centered
      title="Report status not updated for the following workorders"
      closable={false}
      open
      onCancel={() => toggleModal(false)}
      maskClosable={false}
      keyboard={false}
      className="UnchangedWOModal"
      width="70vw"
      footer={[closeButton]}
    >
      <div className="UnchangedWOModal__TableContainer">
        <Table
          sticky
          dataSource={woList}
          rowKey={(row) => row.workorder_id}
          className="UnchangedWOModal__Table"
          pagination={false}
          scroll={{ y: "75vh" }}
        >
          <Table.Column
            title="Work Order ID"
            dataIndex="workorder_id"
            key="workorder_id"
          />
          <Table.Column
            title="Report ID"
            dataIndex="report_id"
            key="report_id"
          />
          <Table.Column
            title="Reason"
            dataIndex="reason"
            key="reason"
            render={(value) => value || "-"}
          />
        </Table>
      </div>
    </Modal>
  );
}
